export const css = {
    icon: '_29RvxPMs',
    clockIcon: 'lWgwpCU1',
    eyeIcon: '_3AtGRFBT',
    eyeSlashIcon: '_3mei70Qn',
    plusIcon: '_3FXI0YEz',
    minusIcon: 'Zo76xPQW',
    checkIcon: 'Qkzz_co0',
    closeIcon: '_2ON_e3xw',
    leftIcon: 'uPd4-qZf',
    rightIcon: '_3AdyLlhz',
    upIcon: 'dNdUaqFC',
    downIcon: '_3IYHDDKD',
    upAltIcon: '_2uO_HVnz',
    downAltIcon: '_1v0n4vZd',
    searchIcon: '_3GJXcqnX',
    barsIcon: '_1ESjA5XL',
    settingsIcon: '_3v3YubFD',
    alertIcon: 'UDaN8y7R',
    helpIcon: '_3N5SVRIA',
    infoIcon: '_1Cyl0ciE',
    cancelIcon: 'Kkfx1PJ1',
    checkedBoxIcon: 'tQWwR8FH',
    phoneIcon: '_1IoIV7i6',
    editIcon: '_3kKJuGJP',
    dateIcon: 'RzS7O7O2',
    linkIcon: '_2dV4JeBD',
    locationIcon: '_3QiGpQ4Y',
    secureIcon: '_1Bn76vSC',
    mailIcon: '_3oHWt5tm',
    starIcon: '_1fynUFOM',
    ' _key': 'apic-theme/dojo/icon'
};
export default css;
